import React from "react";
import PropTypes from "prop-types";
import { useFormContext, Controller } from "react-hook-form";
import {
  Row,
  Col,
  InputGroup,
  Input,
  InputGroupAddon,
  Label,
} from "reactstrap";
import EditorFormSection from "../../EditorFormSection";
import yourText_mirrored_en from "../../../assets/images/yourText-mirrored-en.svg";

const AdditionalOptionsSection = (
  { isOpen, togglePanel, getBorderMax, extraOptions },
  context
) => {
  const { control } = useFormContext();

  return (
    <EditorFormSection
      help={context.t("FileEditor.additionalOptions.help")}
      panelName="extra"
      panelTitle={context.t("additional options")}
      open={isOpen}
      toggle={togglePanel}
    >
      <Row>
        {extraOptions.underglass && (
          <Controller
            name="underglass"
            control={control}
            render={({ field }) => (
              <Col xs={6} className="text-center">
                <img
                  src={yourText_mirrored_en}
                  alt={context.t("reverse cut")}
                  className="img-fluid mb-2 w-100"
                  loading="lazy"
                />
                <InputGroup className="form-check">
                  <Label className="form-check-label text-bold">
                    <Input
                      {...field}
                      type="checkbox"
                      className="form-check-input"
                    />
                    {context.t("reverse cut")}
                  </Label>
                </InputGroup>
                <p className="text-left semi-small mt-2">
                  {context.t(
                    "We'll cut your image backwards so it can be read normally from outside the window. Some colors may look slightly different depending on your window."
                  )}
                </p>
              </Col>
            )}
          />
        )}
        {extraOptions.border && (
          <Controller
            name="border"
            control={control}
            rules={{ min: 0, max: getBorderMax() }}
            render={({ field }) => (
              <Col xs={6}>
                <h5>{context.t("Image Border")}</h5>
                <InputGroup>
                  <Input
                    {...field}
                    type="number"
                    className="form-control"
                    min={0}
                    max={getBorderMax()}
                  />
                  <InputGroupAddon addonType="append">cm</InputGroupAddon>
                </InputGroup>
                <p className="text-left semi-small">
                  {context.t(
                    "Here you can put on an additional white edge around your motive.(This is not shown in the preview)"
                  )}
                </p>
              </Col>
            )}
          />
        )}
      </Row>
    </EditorFormSection>
  );
};

AdditionalOptionsSection.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  togglePanel: PropTypes.func.isRequired,
  getBorderMax: PropTypes.func.isRequired,
  extraOptions: PropTypes.object.isRequired,
};

AdditionalOptionsSection.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default AdditionalOptionsSection;
